// extracted by extract-css-chunks-webpack-plugin
module.exports = {"day":"day_1UU0L","title":"title_3QqRd","content":"content_2W5k8","mask":"mask_3HBpM","mask_active":"mask_active_3c8U-"};